import React, { useState, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';

import { useReportPage } from 'shared/hooks';
import { Loader } from 'ui';
import { RectangularScale } from './RectangularScale';
import { CircleScale } from './CircleScale';

const RankingModal = lazy(() => import('./RankingModal'));

const rankingItemUseStyles = makeStyles(theme => ({
  itemTitle: {
    paddingLeft: theme.spacing(2),
    fontSize: useReportPage ? 12 : 16,
    fontWeight: 500,
  },
}));

const RankingItem = ({ title, total, section, entityName }) => {
  const [isOpen, setIsOpen] = useState(false);

  const rankingItemClasses = rankingItemUseStyles();
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <Grid item xs>
      <Typography variant="h6" className={rankingItemClasses.itemTitle}>
        {title}
      </Typography>
      <Box p={useReportPage ? 0 : 2}>
        <Grid container>
          <Grid item xs={5}>
            <RectangularScale {...section} />
          </Grid>
          <Grid item xs={7}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link component="button" onClick={handleOpen}>
              <CircleScale {...section} total={total} />
            </Link>
          </Grid>
        </Grid>
      </Box>
      <Dialog open={isOpen} maxWidth="md" fullWidth>
        <Suspense fallback={<Loader center />}>
          <RankingModal onClose={handleClose} data={section.betterScores} entityName={entityName} />
        </Suspense>
      </Dialog>
    </Grid>
  );
};

RankingItem.propTypes = {
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  section: PropTypes.object.isRequired,
  entityName: PropTypes.string.isRequired,
};

export { RankingItem };
